var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dsf-exam-layout", {
    attrs: { "exam-loading": _vm.loading, "not-data": _vm.notData },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "space-between" } },
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("h3", [_vm._v("错题练习")]),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "user" }, [
                    _vm._v(
                      _vm._s(_vm.userName || _vm.dsf.cookies.get("user_name"))
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "left",
        fn: function () {
          return [
            _c("p", { staticClass: "sub-title list bg pd-10" }, [
              _vm._v("答题卡"),
            ]),
            _c(
              "div",
              { staticClass: "card-list" },
              [
                _c(
                  "el-row",
                  { staticClass: "card-tips pd-10" },
                  [
                    _c("el-col", { staticClass: "a1", attrs: { span: 8 } }, [
                      _vm._v(" 正确：" + _vm._s(_vm.rightNum) + " "),
                    ]),
                    _c(
                      "el-col",
                      { staticClass: "a2 error", attrs: { span: 8 } },
                      [_vm._v(" 错误：" + _vm._s(_vm.unrightNum) + " ")]
                    ),
                    _c(
                      "el-col",
                      { staticClass: "a3 not-answer", attrs: { span: 8 } },
                      [
                        _vm._v(
                          " 未答：" +
                            _vm._s(
                              _vm.questionsNum - _vm.rightNum - _vm.unrightNum
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("p", { staticClass: "sub-title list pd-10" }, [
                  _vm._v("共" + _vm._s(_vm.questionsNum) + "题"),
                ]),
                _c(
                  "div",
                  { staticClass: "question-list" },
                  _vm._l(_vm.questionsNum, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item,
                        staticClass: "item",
                        class: [
                          { active: index == _vm.wrongExerciseNum - 1 },
                          _vm.allStatus[index],
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.go(index + 1)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(index + 1) + " ")]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "main",
        fn: function () {
          return [
            _vm.practice.num
              ? [
                  _c("p", {
                    staticClass: "sub-title list bg pd-20",
                    domProps: { innerHTML: _vm._s(_vm.practice.items.text) },
                  }),
                  _c("div", { staticClass: "exam-content" }, [
                    _c("div", { staticClass: "question" }, [
                      _c(
                        "div",
                        { staticClass: "left" },
                        [
                          _c("dsf-exam-item-box", {
                            key: _vm.previewStatus,
                            attrs: {
                              type: "practice",
                              readOnly: _vm.previewStatus,
                              "preview-status": _vm.previewStatus,
                              subjects: _vm.practice,
                              "hide-mark": true,
                              "exam-index": _vm.wrongExerciseNum - 1,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "right",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "item" },
              [
                _c("p", { staticClass: "txt" }, [_vm._v("当前进度")]),
                _c("el-progress", {
                  attrs: {
                    percentage: _vm.percentageNumber,
                    format: _vm.format,
                  },
                }),
              ],
              1
            ),
            _c("dsf-setting-font-size"),
            _vm.practice && _vm.wrongExerciseNum > 1
              ? _c(
                  "div",
                  { staticClass: "exam-submit" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "exam-post before",
                        on: {
                          click: function ($event) {
                            return _vm.go(_vm.wrongExerciseNum - 1)
                          },
                        },
                      },
                      [_vm._v(" 上一题 ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.practice
              ? _c(
                  "div",
                  { staticClass: "exam-submit" },
                  [
                    _c(
                      "el-button",
                      { staticClass: "exam-post", on: { click: _vm.examPost } },
                      [_vm._v("下一题")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }